import { Injectable } from "@angular/core";
import { BackendService } from "../backend/backend.service";
import { AuthenticationService } from "../authentication/authentication.service";
import { CoreService } from "../core/core.service";

@Injectable({
  providedIn: "root"
})
export class SurveyQuestionsService {
  private path = "/survey-questions";
  private pathlang = "/languages";

  constructor(
    private backendService: BackendService,
    private auth: AuthenticationService,
    private core: CoreService
  ) {}


 saveSurveyQuestion(survey) {
    return this.backendService.post(this.path + "/", survey);
  }

  getSurveyQuesById(surveyquestionid) {
    return this.backendService.get(this.path + "/qb/" + surveyquestionid);
  }

  
  getDashboard() {
    return this.backendService.get(this.path + "/question/dashboard");
  }
  
  getSurveySummary(surveyquestionid) {
    return this.backendService.get(this.path + "/qb/" + surveyquestionid + "/summary");
  }

  getSurveyErrors(surveyquestionid) {
    return this.backendService.get(this.path + "/qb/" + surveyquestionid + "/errors");
  }

  
  getQuestions(surveyquestionid) {
    return this.backendService.get(this.path + "/qb/" + surveyquestionid + "/questions");
  }

  getQuestionById(surveyquestionid, qid) {
    return this.backendService.get(
      this.path + "/qb/" + surveyquestionid + "/questions/" + qid
    );
  }

  approveSurvey(surveyquestionid) {
    return this.backendService.post(this.path + "/qb/" + surveyquestionid + "/approve", {});
  }

  deleteSurveyQuestions(surveyquestionid) {
    return this.backendService.post(this.path + "/qb/" + surveyquestionid + "/delete", {});
  }


}
